/**
 * @generated SignedSource<<9fbf224f115d08a50934b2c78e9d2b43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardHeader_updateWorkItemFieldsActionRenderer$data = {
  readonly issueTypeField: {
    readonly issueType: {
      readonly avatar: {
        readonly small: string | null;
      } | null;
      readonly name: string;
    } | null;
  } | null;
  readonly key: string;
  readonly summaryField: {
    readonly text: string | null;
  } | null;
  readonly webUrl: AGG$URL | null;
  readonly " $fragmentType": "cardHeader_updateWorkItemFieldsActionRenderer";
};
export type cardHeader_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: cardHeader_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardHeader_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cardHeader_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraSingleLineTextField",
      "kind": "LinkedField",
      "name": "summaryField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "text"
        }
      ]
    },
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "small"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "5b3b52ad60affa4654ab2d2c0cbc2470";

export default node;
